<template>
  <v-container max-width="800">
    <div class="text-h6 font-weight-bold mb-4 d-flex align-center" style="gap:8px;">
      <v-icon color="grey-darken-3">mdi-help-circle</v-icon>
      Help &amp; User Guide
    </div>

    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel v-for="item in helpItems" :key="item.title">
        <v-expansion-panel-title>
          <div class="d-flex align-center" style="gap:10px;">
            <v-icon :color="item.color" size="20">{{ item.icon }}</v-icon>
            <span class="text-body-1 font-weight-medium">{{ item.title }}</span>
          </div>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <p class="text-body-2 text-medium-emphasis" v-html="item.body" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card variant="tonal" color="grey-darken-3" class="pa-4" rounded="lg">
      <div class="d-flex align-center" style="gap:10px;">
        <v-icon>mdi-headset</v-icon>
        <div>
          <div class="text-subtitle-2 font-weight-bold">Still need help?</div>
          <div class="text-body-2 mt-1">Contact your system administrator for further support.</div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      helpItems: [
        {
          icon: "mdi-information-outline",
          color: "blue",
          title: "What is this system?",
          body: "This is an Event Management Dashboard where you can manage events, attendees, and track real-time check-ins.",
        },
        {
          icon: "mdi-calendar-plus",
          color: "green",
          title: "Adding Events",
          body: 'Go to the <strong>Events</strong> page and click <strong>Add Event</strong>. Fill in the event name, description, date, images, and maximum invitations.',
        },
        {
          icon: "mdi-account-group",
          color: "teal",
          title: "Managing Attendees",
          body: "Open any event to see its attendees. You can bulk-upload attendees via an Excel file, edit individual records, or delete them.",
        },
        {
          icon: "mdi-email-send-outline",
          color: "purple",
          title: "Invitations",
          body: 'Use the <strong>Invitations</strong> page to register attendees individually. A PDF invitation with an embedded QR code is automatically generated and emailed to the attendee.',
        },
        {
          icon: "mdi-qrcode-scan",
          color: "orange",
          title: "Check-In System",
          body: 'Go to <strong>Scan Attendee</strong> and point the camera at an attendee\'s QR code, or connect a USB scanner and scan directly. The attendee\'s check-in is recorded instantly.',
        },
        {
          icon: "mdi-view-dashboard",
          color: "indigo",
          title: "Dashboard Statistics",
          body: "The dashboard shows total events, attendees, check-in rates, gender breakdown, upcoming events, and top events by attendance — all updated in real time.",
        },
        {
          icon: "mdi-tools",
          color: "red",
          title: "Troubleshooting",
          body: "Ensure the backend server is running on port 8888. Check the browser console for CORS or connection errors. Make sure the MySQL database is accessible and seeded with data.",
        },
      ],
    };
  },
};
</script>
